import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { History } from "history";
import { FormattedMessage } from "react-intl";

import Input from "components/Input";
import InputFile from "components/InputFile";
import ToggleSwitch from "components/ToggleSwitch";
import CNBTextArea from "components/CNBTextArea";
import Button from "components/Button";
import CNBDatePicker from "components/CNBDatePicker";
import BackgroundBlock from "../../deliveryNotes/partials/BackgroundBlock";
import NotificationsActions from "../actions";
import { INotification } from "models/.";

import "./style.scss";

interface IProps {
  history: History;
  match: any;
  getNotification: (id) => void;
  saveNotification: (params) => void;
  currentItem: INotification;
}

interface IState {
  [fieldName: string]: any;
}

class NewNotification extends React.Component<IProps, IState> {
  public constructor(props) {
    super(props);

    this.state = {};
  }

  public componentDidMount() {
    const {
      match: { params },
      getNotification
    } = this.props;

    if (params.id) {
      getNotification(params.id);
    }
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.currentItem && !this.props.currentItem) {
      this.setState(nextProps.currentItem);
    }
  }

  private handleFieldChange(name, value) {
    this.setState({ [name]: value });
  }

  private handleSubmit = e => {
    e.preventDefault();
    const formData = new FormData();
    const { Files, ...data } = this.state;

    _.forEach(data, (value, key) => formData.append(key, value));
    if (Files && Files._id) {
      formData.append("Files", JSON.stringify(Files));
    } else if (Files && !Files._id) {
      formData.append("Files", Files);
    }

    this.props.saveNotification(formData);
  };

  private removeFile = () => {
    this.setState({ Files: undefined });
  };

  public render() {
    const {
      DateFrom = new Date(),
      DateTo = new Date(),
      Title_nl = "",
      Title_en,
      Text_nl = "",
      Text_en,
      Files,
      Important
    } = this.state;
    const disabled = !(DateFrom && DateTo && Title_nl && Text_nl);

    return (
      <div id="new-notification">
        <FormattedMessage id="NOTIFICATIONS" tagName="h1" />
        <BackgroundBlock className="notification-form">
          <div className="datum">
            <FormattedMessage id="NOTIFICATIONS_DATE" tagName="label" />
            <CNBDatePicker
              startDate={DateFrom}
              onChange={value => this.handleFieldChange("DateFrom", value)}
              showTimeSelect
              dateFormat="dd-MM-yyyy hh:mm"
            />
          </div>
          <div className="datum">
            <FormattedMessage id="NOTIFICATIONS_END_DATE" tagName="label" />
            <CNBDatePicker
              startDate={DateTo}
              onChange={value => this.handleFieldChange("DateTo", value)}
              showTimeSelect
              dateFormat="dd-MM-yyyy hh:mm"
            />
          </div>
          <Input
            value={Title_nl}
            label="TITLE_NL"
            placeholder="TITLE_NL"
            onChange={e => this.handleFieldChange("Title_nl", e.target.value)}
          />
          <Input
            value={Title_en}
            label="TITLE_EN"
            placeholder="TITLE_EN"
            onChange={e => this.handleFieldChange("Title_en", e.target.value)}
          />
          <InputFile
            label="NOTIFICATIONS_FILES"
            name="files"
            extensions={["pdf"]}
            files={Files && [Files]}
            remove={this.removeFile}
            onChange={([file]) => this.handleFieldChange("Files", file)}
          />
          <CNBTextArea
            value={Text_nl}
            label="TEXT_NL"
            rows={6}
            onChange={e => this.handleFieldChange("Text_nl", e.target.value)}
          />
          <CNBTextArea
            value={Text_en}
            label="TEXT_EN"
            rows={6}
            onChange={e => this.handleFieldChange("Text_en", e.target.value)}
          />
          <ToggleSwitch
            label="IMPORTANT"
            name="important"
            on={Important}
            onClick={() => this.handleFieldChange("Important", !Important)}
          />
        </BackgroundBlock>
        <div className="submit-btn">
          <Button kind="gray" onClick={() => this.props.history.back()}>
            CANCEL
          </Button>
          <Button
            kind="primary"
            disabled={disabled}
            onClick={this.handleSubmit}
          >
            SAVE
          </Button>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    currentItem: state.notifications.currentItem
  }),
  {
    getNotification: NotificationsActions.getNotification,
    saveNotification: NotificationsActions.saveNotification
  }
)(NewNotification);
